type NavbarSiteKey = 'cert' | 'prep' | 'jobs';

interface NavbarSite {
  key: NavbarSiteKey;
  name: string;
  href: string;
  logoColor: string;
}

const NavbarSites: NavbarSite[] = [
  {
    key: 'cert',
    name: 'Cert',
    href: 'https://cert.240.org',
    logoColor: 'green',
  },
  {
    key: 'prep',
    name: 'Prep',
    href: '/',
    logoColor: 'orange',
  },
  {
    key: 'jobs',
    name: 'Jobs',
    href: 'https://jobs.240.org',
    logoColor: 'purple',
  },
];

const getLinkStyle = (key: NavbarSiteKey, isSelected: boolean) => {
  const baseStyle = 'flex items-center gap-2 px-4 py-2 my-3 hover:no-underline';

  const selectedStyles: Record<NavbarSiteKey, string> = {
    cert: 'bg-[#05a892] rounded-full',
    prep: 'bg-primary rounded-full',
    jobs: 'bg-[#34195F] rounded-full',
  };

  return `${baseStyle} ${isSelected ? selectedStyles[key] : ''}`;
};

const getTextStyle = (key: NavbarSiteKey, isSelected: boolean) => {
  if (isSelected) {
    return 'text-white';
  }

  const textColors: Record<NavbarSiteKey, string> = {
    cert: 'text-[#05a892]',
    prep: 'text-[#F37037]',
    jobs: 'text-[#34195F]',
  };

  return textColors[key];
};

interface GlobalNavbarProps {
  selectedSite: NavbarSiteKey;
}

export function GlobalNavbar({ selectedSite }: GlobalNavbarProps) {
  return (
    <nav className="flex w-full justify-center gap-5 bg-[#feeae0]">
      {NavbarSites.map(({ key, name, href, logoColor }) => {
        const isSelected = selectedSite === key;
        return (
          <a key={key} href={href} className={getLinkStyle(key, isSelected)}>
            <img
              src={isSelected ? '/logo-white.png' : `/logo-${logoColor}.png`}
              alt=""
              width="32"
              height="23"
            />
            <span
              className={`text-base font-semibold ${getTextStyle(key, isSelected)}`}
            >
              {name}
            </span>
          </a>
        );
      })}
    </nav>
  );
}
